<template>
  <div>
    <b-row>
      <b-col>
        <b-form-group
          label="Turnaround"
          :label-cols="3"
          :state="!$v.selected.$invalid"
          invalid-feedback="Required"
        >
          <multiselect
            :placeholder="'Select Turnaround'"
            v-model="selected"
            :options="options"
            label="text"
            trackBy="value"
          ></multiselect>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import TurnaroundCollection from "../../collections/lab/TurnaroundCollection";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "TurnAroundSelect",
  components: {
    Multiselect
  },
  mixins: [validationMixin, ToastNotifications],
  props: {
    turnArounds: {
      type: Object,
      default: () => new TurnaroundCollection()
    },
    selectedTurnAround: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    selected: {
      get() {
        return (
          (this.selectedTurnAround &&
            this.options.find(
              option => option.value === this.selectedTurnAround.id
            )) ||
          null
        );
      },
      set(selected) {
        let turnaround = null;
        if (this.turnArounds && selected && this.turnArounds.models.length) {
          this.turnArounds.models.forEach(turnAround => {
            if (turnAround.id === selected.value) {
              turnaround = turnAround;
            }
          });
        }
        this.$emit("onTurnAroundSelect", turnaround);
      }
    }
  },
  data() {
    return {
      options: []
    };
  },
  validations: {
    selected: { required }
  },
  methods: {
    populateOptions() {
      this.options = [];
      if (this.turnArounds && this.turnArounds.models.length) {
        this.turnArounds.models.forEach(turnAround => {
          this.options.push({
            value: turnAround.id,
            text:
              turnAround.name +
              " (" +
              turnAround.description +
              ")" +
              " (" +
              this.formatSurchage(turnAround) +
              ")"
          });
        });
      }
    },
    formatSurchage(turnAround) {
      switch (turnAround.surcharge_type) {
        case "percent":
          return turnAround.surcharge + "% Surcharge";
        case "flat":
          return "$" + turnAround.surcharge + " Surcharge";
      }
      return "Surcharge not specified";
    }
  },
  created() {
    this.populateOptions();
  }
};
</script>
